import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import fetch from 'isomorphic-fetch';

import introspectionQueryResultData from './fragmentTypes.json';
import { getSession } from '../../src/services/useSession';
import { getShareToken } from '../../src/services/shares';
import { errorLink, responseErrorNormalizerLink } from './apollo-link-error';
import versionTrackerLink from './apollo-version-tracker';
import requestRuntimeLoggerLink from './apollo-request-runtime-logger';

const cache = new InMemoryCache({
  possibleTypes: introspectionQueryResultData.__schema.types.reduce((acc, type) => {
    if (type.possibleTypes) {
      acc[type.name] = type.possibleTypes.map((t) => t.name);
    }
    return acc;
  }, {}),
 });
const httpLink = new HttpLink({ uri: `${process.env.GATSBY_API_URL}/graphql` });

const authLink = setContext((_, { headers = {} }) => {
  const requestStartedAt = new Date();
  // If Authorization already present, do not modify headers
  if (headers.Authorization) return { headers, requestStartedAt };

  const { accessToken } = getSession();
  const shareToken = getShareToken();

  const newHeaders = {
    ...headers,
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(shareToken && { "X-ShareToken": shareToken }),
  };

  return {
    headers: newHeaders,
    requestStartedAt,
  };
});

const client = new ApolloClient({
  cache,
  fetch,
  link: ApolloLink.from([
    authLink, // inserts Authorization header
    responseErrorNormalizerLink, // fixes malformed errors before they reach the errorLink
    errorLink, // catches errors and handles them: ACL refresh for not_authorized, token refresh for expired_token, logout for invalid auth
    versionTrackerLink, // notifies the user when new version of this React app is available
    requestRuntimeLoggerLink, // outputs slow requests to console.warn
    httpLink, // runs the query
  ]),
});

export default client;
